// This file is generated by next-core EcmascriptClientReferenceModule.
import { registerClientReference } from "react-server-dom-turbopack/server";
export const PAGE_DEFS = registerClientReference(
    function() { throw new Error("Attempted to call PAGE_DEFS() from the server but PAGE_DEFS is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/src/app/(app)/AppShell.tsx",
    "PAGE_DEFS",
);
export default registerClientReference(
    function() { throw new Error("Attempted to call the default export of [project]/src/app/(app)/AppShell.tsx from the server, but it's on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/src/app/(app)/AppShell.tsx",
    "default",
);
